import React, { useState } from 'react'

import { isDesktop } from 'App/app/ui';

import './home-select-cuisine.scss'

const linkStyle = {
  display: 'flex',
  height: '100%',
  flexFlow: 'column nowrap',
  justifyContent: 'space-between',
}

const categories = [
  {
    name: 'Lokalna',
    img: '/storage/img/lubje/food/shashlyk.jpg',
    url: '/zamawiaj?rodzaj-kuchni=Regionalna',
  },
  {
    name: 'Burgery',
    img: '/storage/img/lubje/food/burger.jpg',
    url: '/zamawiaj?rodzaj-kuchni=Burgery',
  },
  {
    name: 'Azjatycka',
    img: '/storage/img/lubje/food/oriental.jpg',
    url: '/zamawiaj?rodzaj-kuchni=Azjatycka',
  },
  {
    name: 'Makaron',
    img: '/storage/img/lubje/food/pasta.jpg',
    url: '/zamawiaj?rodzaj-kuchni=Makaron',
  },
];

const HomeSelectCuisine = () => {
  const step = isDesktop() ? 4 : 2;
  const [visibleCategoriesNum, setVisibleCategoriesNum] = useState(step);
  const canShowMoreCategories = visibleCategoriesNum < categories.length;
  const showMoreCategories = () => setVisibleCategoriesNum(visibleCategoriesNum + step);

  return (
    <section className="home-select-cuisine container">
      <h2 className="lubje-title text-center">Co ja dzisiaj Lub*JE?</h2>
      <h5 className="home-select-cuisine__subtitle">
        Wybierz kuchnię i zobacz listę restauracji
      </h5>
      <div className="xs-col-md-row home-select-cuisine__list-wrapper">
        {categories.slice(0, visibleCategoriesNum).map(item => (
          <article className="home-select-cuisine__item" key={item.name}>
            <a href={item.url} style={linkStyle}>
              <img
                src={item.img}
                alt={`Zamów ${item.name} z dostawą`}
                className="home-select-cuisine__item-img"
              />
              <h4 className="home-title home-select-cuisine__item-title">
                {item.name}
              </h4>
            </a>
          </article>
        ))}
      </div>
      {canShowMoreCategories && (
        <div className="text-center mt-3">
          <button
            type="button"
            className="home-select-cuisine__more"
            onClick={showMoreCategories}
          >
            więcej kategorii
          </button>
        </div>
      )}
    </section>
  )
}

export default HomeSelectCuisine
